import { useI18n } from 'vue-i18n';

export const useFormatters = () => {
  const { t } = useI18n();

  const formatInteger = (value) => {
    if (value === null || value === undefined) return '';
    return Number(value).toLocaleString('en-US');
  };

  const formatNumber = (value, options = { minimumFractionDigits: 2, maximumFractionDigits: 2 }) => {
    if (value === null || value === undefined) return '';
    const num = Number(value);
    return num.toLocaleString('en-US', options);
  };

  const formatCurrency = (value, currencyLabel = '') => {
    if (value === null || value === undefined) return '';
    const formatted = Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return `${currencyLabel}${formatted}`;
  };

  const formatDurationDays = (seconds) => {
    if (Number.isNaN(Number(seconds)) || !seconds) return 0;
    const total = Number(seconds);
    const d = Math.floor(total / (3600 * 24));
    const h = Math.floor((total % (3600 * 24)) / 3600);
    const m = Math.floor((total % 3600) / 60);

    const dDisplay = d > 0 ? t('offers.cardOffers.pluralDays', { days: d }, d) : '';
    const hDisplay = h > 0 ? `${h}${h === 1 ? ` ${t('customReports.hour')} ` : ` ${t('offers.cardOffers.hours')} `}` : '';
    const mDisplay = m > 0 ? `${m}${m === 1 ? ` ${t('customReports.minute')} ` : ` ${t('offers.cardOffers.minutes')} `}` : '';

    return `${dDisplay}${hDisplay}${mDisplay}`;
  };

  const timeFn = (type, count) => {
    if (type === 'days') return t('offers.cardOffers.pluralDays', { days: count }, count);
    if (type === 'hours') return `${count} ${t('offers.cardOffers.hours')}`;
    return '';
  };

  return {
    formatInteger,
    formatNumber,
    formatCurrency,
    formatDurationDays,
    timeFn,
  };
};

export default useFormatters;
